<script>
    export default {
        props: [
            'stat', 'statTitle', 'locale'
        ],
        data: function(){
            return {
                loading: true,
                maximized: false,
            }
        },
        mounted: function(){
        },
        methods: {
            maximizeToggle: function(){
                var statistic = this;

                if(statistic.maximized){
                    statistic.maximized = false;
                    $(statistic.$el).css({
                        "position": "relative",
                        "width": "auto",
                        "height": "auto",
                        "z-index": "auto",
                    });
                    $("> .box-body", statistic.$el).css({
                        "width": "auto",
                        "height": "auto",
                        "overflow-x": "hidden",
                        "overflow-y": "hidden",
                    });
                    $("html").css({
                        "overflow-x": "hidden",
                        "overflow-y": "scroll",
                    });
                }else{
                    statistic.maximized = true;
                    $("html").css({
                        "overflow-x": "hidden",
                        "overflow-y": "hidden",
                    });
                    $(statistic.$el).css({
                        "position": "fixed",
                        "top": 0,
                        "left": 0,
                        "width": "100%",
                        "height": "100%",
                        "z-index": 1050,
                    });
                    $("> .box-body", statistic.$el).css({
                        "width": "100%",
                        "height": "calc(100% - " + $("> .box-header", statistic.$el).outerHeight() + "px)",
                        "overflow-x": "hidden",
                        "overflow-y": "auto",
                    });
                }

                Event.$emit('maximizeToggle', statistic, event);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/app/components/widgets/statistics/statistic.vue